import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    sectionUrl: '/services/webarchiv/',
  }) as const) satisfies ConfigFn

export default config
